import * as React from "react";

function SvgPen(props) {
  return (
    <svg width={29} height={28} fill="none" viewBox="0 0 29 28" {...props}>
      <g clipPath="url(#pen_svg__clip0)">
        <path d="M25.0686 8.15396C26.0126 7.20894 26.0126 5.67839 25.0686 4.73388L22.0432 1.70801C21.0992 0.763997 19.5666 0.763997 18.6226 1.70801L15.7765 4.55514L22.1756 10.9996L25.0686 8.15396ZM14.6416 5.69349L1.56647 18.7687C1.454 18.8811 1.37747 19.0243 1.34615 19.1803L0.0200075 25.811C-0.0927703 26.3749 0.404258 26.8718 0.968046 26.7591L7.59878 25.4324C7.75475 25.4013 7.89789 25.3246 8.01036 25.2123L21.0855 12.1371L14.6416 5.69349ZM27.7923 24.3607H12.4868C11.8172 24.3607 11.2785 24.8994 11.2785 25.5691C11.2785 26.2387 11.8172 26.7774 12.4868 26.7774H27.7923C28.4594 26.7774 29.0007 26.2362 29.0007 25.5691C29.0007 24.8994 28.462 24.3607 27.7923 24.3607Z" />
      </g>
      <defs>
        <clipPath id="pen_svg__clip0">
          <path d="M0 0H29V28H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgPen;
